import { IModelDataV1, Model } from '@df/catalog/model';

export interface IRating {
    rating: number;
    count: number;
}

export interface IReviewData extends IModelDataV1, IRating {
    author?: string;
    date?: string;
    title?: string;
    content?: string;
}

/**
 * Review model representing magento review
 */
export class Review extends Model<IReviewData> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'review';
}
